// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3JLXM","modalFooterButton":"ModalNotes_modalFooterButton__3gaEK"};